import BrV from 'br-validations'

export const PisValidator = (pis) => {
  return BrV.pis.validate(pis)
}
